import React from "react";
import { useSiteMetadata } from "../../hooks/use-site-metadata";

export const SEO = ({ title = '', description = '', imageUrl, children }) => {

  const { siteUrl, title: defaultTitle, description: defaultDescription, author } = useSiteMetadata();

  const defaultImage = "https://finde.gba.gob.ar/sites/default/files/styles/max_1300x1300/public/2022-07/PEABODY_1080X1080%20-%20Mauro%20Labusta.jpg.webp?itok=rMAbJRTF";

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: imageUrl || defaultImage,
    author: author,
    url: siteUrl
  }

  return (
    <html lang="es-AR">
      <head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.url} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:image" content={seo.image} />
        <meta property="og:image:secure_url" content={seo.image} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta name="twitter:image" content={seo.image} />
        
        { children }
      </head>
    </html>
  );
}

// export default SEO;
